/* eslint-disable @typescript-eslint/camelcase */
export default process.env.NODE_ENV === "production" //&& process.env.npm_config_stage === "prod"
  ? //PROD
    {
      oauth: {
        discord: {
          client_id: "721324422669008926",
          auth_url: "https://discord.com/oauth2/authorize",
          response_type: "code",
          scope: "identify",
          prompt: "none",
          width: 480
        }
      }
    }
  : //DEV
    {
      oauth: {
        discord: {
          client_id: "794673338118307882",
          auth_url: "https://discord.com/oauth2/authorize",
          response_type: "code",
          scope: "identify",
          prompt: "none",
          width: 480
        }
      }
    };
